import { initComponent } from './core/init-component.js'
import { bindAll } from './utils/bind-all.js'

initComponent('.js-announcement-bar', section => {
  bindAll(section, '.js-announcement-open-newsletter-popup', 'click', (e) => {
    e.preventDefault()
    const modal = document.querySelector('hh-newsletter-modal')
    if (!modal) {
      return
    } 

    modal.disabled = false
    modal.open = true
  })
  return {}
})
